export const CORE_SERVICES_EXPIRATION_TYPES = {
	TIME_ZONE: 'TIME_ZONE',
	TIME_DUTATION: 'TIME_DUTATION',
};
